export const fetchFullDataQMF = async () => {
  const conn_name = "crmwidgetconnection";
  const apiUrl =
    "https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/Quality_Manual_full_Edit_Report/4599841000005801003";

  const req_data = {
    method: "GET",
    url: apiUrl,
    param_type: 1,
  };

  try {
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, req_data);

    if (!response || !response.details || !response.details.statusMessage) {
      console.error("❌ Invalid response structure:", response);
      return [];
    }

    let records = response.details.statusMessage.data;

    // ✅ Handle case where records is not an array
    if (!Array.isArray(records)) {
      console.warn("⚠️ Fetched data is not an array, wrapping it in an array.");
      records = [records];
    }

    console.log("✅ Parsed Full Data QMF Records:", records);

    return records.map((item) => ({
      id: item.ID,
      fullDataText: item.Multi_Line || "No full data available",
      ...item,
    }));
  } catch (error) {
    console.error("❌ Error fetching Full Data QMF:", error);
    return [];
  }
};
